define(function(require) {
    const Cell = require('../BaseCell');
    const _ = require('underscore');

    /**
     * Render a backbone view in a cell
     * @param {Object} options
     * @returns column definition
     */
    const ViewCell = function(options) {
        return {
            CellClass: Cell,
            options: _.extend(
                {
                    /**
                     * @type Backbone.View
                     */
                    ViewClass: undefined,
                    /**
                     * The options sent to the initialize of ViewClass
                     * @param {Any} data The data for the cell
                     * @param {String} type The type of cell data
                     * @param {Any} row THe full data source for the row
                     * @param {Object} meta Additional info about the cell
                     * @param {Backbone.Model} model The model associated with this row
                     */
                    viewOptionsFn: (data, type, row, meta, model) => {},
                    onGetData: function(data) {
                        if (_.isUndefined(data)) {
                            data = false;
                        }
                        return data;
                    },
                    /**
                     * Rendering the display version of this cell
                     * @param {Any} data The data for the cell
                     * @param {String} type The type of cell data
                     * @param {Any} row THe full data source for the row
                     * @param {Object} meta Additional info about the cell
                     * @param {Object} rowModel Only available in Lotame contexts
                     * @param {Any} translatedValue data transformed by this cell
                     */
                    onDisplay: function(data, type, row, meta, translatedValue, rowModel = undefined) {
                        if (_.isUndefined(translatedValue)) {
                            return false;
                        }
                        const rowId = row[meta.settings.rowId];
                        const model = this.findModel(rowModel, row);

                        //
                        // Custom Rendering so that it fits better into DataTable's rendering.
                        //

                        // Since cid is the rowId, it gets set in the column's data
                        // but don't propagate that through
                        const viewOptions = this.viewOptionsFn(_.omit(data, 'cid'), type, row, meta, model);
                        const view = new this.ViewClass(viewOptions);

                        // Register this view so it can be put into the dom correctly
                        // later in the render flow
                        this.collection.trigger('DataGrid:ViewCell::Register', {
                            view: view,
                            viewPrefix: this.prefix,
                            rowId: rowId
                        });
                        view.render();

                        // Return the view's html surrounded by a wrapper
                        return `<div class="data-grid-cell__view data-grid-cell__view--${this.prefix} ${this.prefix}-${rowId}">${view.el.innerHTML}</div>`;
                    },
                    sortable: false
                },
                options
            )
        };
    };
    return ViewCell;
});
